module.exports = __webpack_public_path__ + "img/qrcode.6c069588.jpg";